import React from 'react';
import styles from './Button.module.scss';

interface ButtonProps {
  children: React.ReactNode;
  width?: string;
  color?: string;
  background?: string;
  disabled?: false;
  // eslint-disable-next-line no-unused-vars
  onClick?: (e: any) => void;
}

const defaultProps = {
  color: '#ffffff',
  width: '20vw',
  background: '#000000',
};

const Button: React.FC<ButtonProps> = ({
  children, color, background, width, onClick, disabled,
}: ButtonProps) => (
  <div
    className={`${styles.button} ${!!disabled && styles.disabled}`}
    onClick={onClick}
    style={{ backgroundColor: `${background}`, color: `${color}`, width: `${width}` }}
    aria-hidden
  >
    {children}
  </div>
);
Button.defaultProps = defaultProps;
export default Button;
